module.exports = __webpack_public_path__ + "img/jfbg1.1f948f46.png";